// Add to cart functionality
document.addEventListener('DOMContentLoaded', function() {
    const addBtn = document.querySelector('.add-to-basket-btn');
    const qtyMinus = document.querySelector('.qty-btn.minus');
    const qtyPlus = document.querySelector('.qty-btn.plus');
    const qtyValueEl = document.querySelector('.qty-value');

    if (!addBtn || !qtyValueEl) return;

    function getQuantity() {
        const n = parseInt(qtyValueEl.textContent, 10);
        return isNaN(n) || n < 1 ? 1 : n;
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function() {
        const n = Math.max(1, getQuantity() - 1);
        qtyValueEl.textContent = n;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function() {
        const n = getQuantity() + 1;
        qtyValueEl.textContent = n;
    });

    addBtn.addEventListener('click', function() {
        const variantId = addBtn.getAttribute('data-variant-id');
        const quantity = getQuantity();
        
        if (!variantId) {
            return;
        }

        addBtn.disabled = true;
        addBtn.textContent = 'ADDING...';

        const requestBody = { id: Number(variantId), quantity: quantity };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(requestBody)
        })
       .then(res => res.json())
       .then(() => {
           // Fetch updated cart and update header bubbles without leaving the page
           return fetch('/cart.js', { credentials: 'same-origin' })
             .then(r => r.json())
             .then(cart => {
                 function ensureCountEl(containerSelector, countClass) {
                     const container = document.querySelector(containerSelector);
                     if (!container) return null;
                     let countEl = container.querySelector('.' + countClass);
                     if (!countEl) {
                         countEl = document.createElement('div');
                         countEl.className = countClass;
                         container.appendChild(countEl);
                     }
                     return countEl;
                 }

                 const mobileCountEl = ensureCountEl('.mobile-basket-container', 'mobile-basket-count');
                 const desktopCountEl = ensureCountEl('.basket-container', 'basket-count');
                 if (mobileCountEl) mobileCountEl.textContent = cart.item_count;
                 if (desktopCountEl) desktopCountEl.textContent = cart.item_count;

                 const evt = new CustomEvent('cart:updated', { detail: cart });
                 document.dispatchEvent(evt);

                 addBtn.textContent = 'ADDED';
                 setTimeout(() => { addBtn.textContent = 'ADD TO BASKET'; addBtn.disabled = false; }, 1000);
             });
       })
       .catch(() => {
           addBtn.textContent = 'ERROR';
           setTimeout(() => { addBtn.textContent = 'ADD TO BASKET'; addBtn.disabled = false; }, 1200);
       });
    });
});

// Quantity Selector Functionality
document.addEventListener('DOMContentLoaded', function() {
    const quantitySelector = document.querySelector('.quantity-selector');
    if (!quantitySelector) return;

    const minusBtn = quantitySelector.querySelector('.qty-btn.minus');
    const plusBtn = quantitySelector.querySelector('.qty-btn.plus');
    const qtyValue = quantitySelector.querySelector('.qty-value');

    let currentQuantity = 1;
    const minQuantity = 1;
    const maxQuantity = 99;

    // Update the display
    function updateQuantity() {
        qtyValue.textContent = currentQuantity;
        
        // Disable/enable buttons based on limits
        minusBtn.disabled = currentQuantity <= minQuantity;
        plusBtn.disabled = currentQuantity >= maxQuantity;
        
        // Update button styles
        if (currentQuantity <= minQuantity) {
            minusBtn.style.opacity = '0.5';
            minusBtn.style.cursor = 'not-allowed';
        } else {
            minusBtn.style.opacity = '1';
            minusBtn.style.cursor = 'pointer';
        }
        
        if (currentQuantity >= maxQuantity) {
            plusBtn.style.opacity = '0.5';
            plusBtn.style.cursor = 'not-allowed';
        } else {
            plusBtn.style.opacity = '1';
            plusBtn.style.cursor = 'pointer';
        }
    }

    // Decrease quantity
    minusBtn.addEventListener('click', function() {
        if (currentQuantity > minQuantity) {
            currentQuantity--;
            updateQuantity();
        }
    });

    // Increase quantity
    plusBtn.addEventListener('click', function() {
        if (currentQuantity < maxQuantity) {
            currentQuantity++;
            updateQuantity();
        }
    });

    // Initialize
    updateQuantity();
});
